/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";
import Header from "layouts/authentication/components/Header";

// Updated background image
import bgImage from "assets/images/homepage.png"; // Ensure this file is placed in your project structure
import zIndex from "@mui/material/styles/zIndex";

function BasicLayout({ image = bgImage, children }) {
  const theme = useTheme();

  // Responsive breakpoints
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px
  return (
    <PageLayout
      sx={{ height: "100vh", overflow: "hidden", overflowY: "auto", position: "relative" }}
    >
      {/* <Header title="" /> */}

      {/* Background Section */}
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: image ? `url(${image})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: "-1",
        }}
      />

      {/* Content Layer */}
      <MDBox px={2} py={isMobile ? 4 : isTablet ? 6 : 8} width="100%" maxWidth="1280px" mx="auto">
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="flex-start"
          sx={{
            minHeight: "calc(100vh - 80px)", // allow room for footer
          }}
        >
          <Grid item xs={12} sm={10} md={6} lg={5} xl={4}>
            {children}
          </Grid>
        </Grid>
      </MDBox>

      <Footer light />
    </PageLayout>
  );
}

// Typechecking props for BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string, // Image URL as a string (optional)
  children: PropTypes.node.isRequired, // Required children elements
};

export default BasicLayout;
